import { render, staticRenderFns } from "./ControlLabel.vue?vue&type=template&id=a4c82f7c&scoped=true"
import script from "./ControlLabel.vue?vue&type=script&lang=js"
export * from "./ControlLabel.vue?vue&type=script&lang=js"
import style0 from "./ControlLabel.vue?vue&type=style&index=0&id=a4c82f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c82f7c",
  null
  
)

export default component.exports